/**
 * 
 * key
 * 
 */


const key = 'bW9udGhXaXNlUGVuZGluZ0NsaWVudENvdW50'

export default key 